import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MappingService } from 'src/app/shared/services/mapping.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { AddressService } from '../../address/service/address/address.service';
import {
  addressType,
  typeCode,
  validForAddressFormatMessage,
  validForCIFormatMessage,
  validForCISizeMessage,
  validForShipmentLineItemsFormatMessage,
} from '../../../utils/constants/strings';
import {
  validAddressFormat,
  validForCIFormat,
  validForShipmentLineItemsFormat,
} from '../../../utils/constants/constant';
import { InvalidDialogComponent } from 'src/app/shared/errors/invalid-dialog/invalid-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit {
  mappingData: any;
  specList: any;
  shipment: any;
  selectedSpec: any;
  selectedLineItemSpec: any = {};
  formDataObj;
  showStatus = false;
  selectedFileName: string;
  uploadFrom: string;
  formDataLineItem: FormData;
  formDataInvoice: FormData;
  formDataAddress: FormData;
  invoiceSpecificationList = [];
  typeCode = typeCode;
  invoiceTypeCode: string = '';
  addressTypeCode: string = '';
  mawb: string = '';
  shipmentID: string = '';
  address: string = '';
  motherStatus: string = '';
  validForShipmentLineItemsFormat = validForShipmentLineItemsFormat;
  validForCIFormat = validForCIFormat;
  typeCodeFileExist = false;
  confirmDialogRef: any;
  selectedFileSize: number = 0;
  @ViewChild('confirmDialog')
  confirmDialog: TemplateRef<any>;
  postalLocationApiKey: any;
  mydhlApiKey: any;
  mydhlApiPassword: any;
  addressType = addressType;
  validAddressFormat = validAddressFormat;

  constructor(
    private configService: ConfigService,
    private mappingService: MappingService,
    private addressService: AddressService,
    private errorDialogService: ErrorDialogService,
    private behaviorService: BehaviourService,
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      address: string;
      isOpeningFrom: string;
      mawb: string;
      motherStatus?: string;
      file_uploadsource?: string;
      shipmentID: string;
    }
  ) {}

  ngOnInit(): void {
    this.behaviorService.sendEvent('');
    this.getUploadComponentInformation();
    this.getCustomerCredentialConfig();
  }

  getUploadComponentInformation() {
    this.uploadFrom = this.data?.isOpeningFrom;
    switch (this.uploadFrom) {
      case 'uploadShipment': {
        this.getmappingFileds();
        this.getMappingOptions();
        break;
      }
      case 'uploadLineItem': {
        this.mawb = this.data?.mawb;
        this.getInvoiceSpecificationList();
        break;
      }
      case 'uploadInvoice': {
        this.mawb = this.data?.mawb;
        this.shipmentID = this.data?.shipmentID;
        this.motherStatus = this.data?.motherStatus;
        break;
      }
      case 'uploadAddress': {
        this.formDataAddress = new FormData();
        break;
      }
    }
  }

  getMappingOptions() {
    const id = 'customer_mapping_specifications';
    this.configService.getListOfMappings(id).subscribe(data => {
      this.specList = data[0];
    });
  }

  specChangeEvent() {
    const id = 'customer_mapping_specifications';
    const specificationName = this.selectedSpec.specifications_id;
    this.configService.getMappingFromOption(id, specificationName).subscribe(data => {
      this.mappingData = data[0];
    });
  }

  getInvoiceSpecificationList() {
    this.configService.getListOfMappings('customer_invoice_specifications').subscribe(data => {
      this.invoiceSpecificationList = data[0];
      this.selectedLineItemSpec = this.invoiceSpecificationList[0];
    });
  }

  lineItemSpecChangeEvent() {
    this.formDataLineItem.set('specifications_id', this.selectedLineItemSpec?.specifications_id);
  }

  invoiceSpecChangeEvent(event) {
    this.invoiceTypeCode = event?.value;
    if (this.mawb) {
      this.formDataInvoice.set('mawb', this.mawb);
    } else if (this.shipmentID) {
      this.formDataInvoice.set('shipmentID', this.shipmentID);
    }
    this.formDataInvoice.set('typeCode', this.invoiceTypeCode);
    this.formDataInvoice.set('replace', String(this.typeCodeFileExist));
  }

  addressTypeChangeEvent(event) {
    this.addressTypeCode = event?.value;
    this.formDataAddress.set('address_type', this.addressTypeCode);
  }

  validateFile(type, allowedTypes, errorMessage) {
    let fileExt = type;
    fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
    if (allowedTypes.indexOf(fileExt.toLowerCase()) < 0) {
      this.errorDialogService.openDialog(errorMessage, false);
      return false;
    } else {
      return true;
    }
  }

  uploadShipmentData(file) {
    if (this.mydhlApiKey == '' || this.mydhlApiPassword == '') {
      const msg = 'alert.myDhlApiCred';
      this.openCustomerCredentialNav(msg);
    } else {
      if (this.selectedSpec == undefined && file.value == '') {
        this.errorDialogService.openDialog('alert.selectSpecFile', false);
        return;
      }
      if (this.selectedSpec == undefined) {
        this.errorDialogService.openDialog('alert.selectSpec', false);
        return;
      }
      if (file.value == '') {
        this.errorDialogService.openDialog('alert.selectFile', false);
        return;
      }
      const formData = this.formDataObj;
      this.formDataObj.append('specifications_id', this.selectedSpec.specifications_id);
      this.mappingService.uploadShipments(formData).subscribe((_data: { file_id: string }) => {
        this.showStatus = true;
        if (_data?.file_id) {
          this.dialogRef.close({ data: _data?.file_id });
        }
        this.behaviorService.sendEvent('uploadSuccessful');
      });
    }
  }

  getmappingFileds() {
    const id = 'field_specifications';
    const fileformat = '';
    this.configService.getMappingFields(id, fileformat).subscribe();
  }

  onFileChange(ev, fileInput) {
    this.showStatus = false;
    this.shipment = [];
    const reader = new FileReader();
    const file = ev.target.files[0];
    if (
      this.validateFile(
        file.name,
        this.validForShipmentLineItemsFormat,
        validForShipmentLineItemsFormatMessage
      )
    ) {
      this.selectedFileName = file.name;
      reader.onload = () => {
        this.formDataObj = new FormData();
        this.formDataObj.append('file', file);
        this.formDataObj.append('upload_type', 'MANUAL');
      };
      reader.readAsBinaryString(file);
    } else {
      fileInput.value = '';
    }
  }

  onLinItemUploadFileChange(ev, fileInput) {
    const file = ev.target.files[0];
    if (
      this.validateFile(
        file.name,
        this.validForShipmentLineItemsFormat,
        validForShipmentLineItemsFormatMessage
      )
    ) {
      this.selectedFileName = file.name;
      this.formDataLineItem = new FormData();
      this.formDataLineItem.append('file', file);
      this.formDataLineItem.append('mawb', this.mawb);
      this.formDataLineItem.append(
        'specifications_id',
        this.selectedLineItemSpec.specifications_id
      );
    } else {
      fileInput.value = '';
    }
  }

  onInvoiceUploadFileChange(event, fileInput) {
    this.typeCodeFileExist = false;
    const file = event.target.files[0];
    const files = event.target.files;

    let totalFileSize = 0;
    let isValidFile = true;

    let fileNames = [];
    for (var i = 0, f; (f = files[i]); i++) {
      if (!this.validateFile(f.name, this.validForCIFormat, validForCIFormatMessage)) {
        isValidFile = false;
      }
      fileNames.push(f.name);
      totalFileSize += f?.size;
    }

    this.selectedFileSize = totalFileSize; //file.size;
    if (isValidFile) {
      this.selectedFileName = fileNames.join(',');
      if (totalFileSize >= 5242880) {
        this.errorDialogService.openDialog(validForCISizeMessage, false);
      } else {
        this.formDataInvoice = new FormData();
        if (this.mawb) {
          this.formDataInvoice.append('mawb', this.mawb);
        } else if (this.shipmentID) {
          this.formDataInvoice.append('shipmentID', this.shipmentID);
        }
        this.formDataInvoice.append('typeCode', this.invoiceTypeCode);
        this.formDataInvoice.append('replace', String(this.typeCodeFileExist));
        for (const f of files) {
          this.formDataInvoice.append('files', f);
        }
      }
    } else {
      fileInput.value = '';
    }
  }

  onAddressUploadFileChange(event, fileInput) {
    const file = event.target.files[0];
    this.selectedFileSize = file.size;
    if (this.validateFile(file.name, this.validAddressFormat, validForAddressFormatMessage)) {
      this.selectedFileName = file.name;
      this.formDataAddress.set('file', file);
    } else {
      fileInput.value = '';
    }
  }

  uploadLineItemsContent() {
    if (this.selectedFileName) {
      this.mappingService.uploadLineItem(this.formDataLineItem).subscribe(() => {
        this.showStatus = true;
        this.behaviorService.sendEvent('lineItemsEvent');
      });
    } else {
      this.errorDialogService.openDialog('alert.chooseFile', false);
    }
  }

  uploadInvoiceContent() {
    if (this.invoiceTypeCode) {
      if (this.selectedFileName) {
        if (this.selectedFileSize >= 5242880) {
          this.errorDialogService.openDialog(validForCISizeMessage, false);
        } else {
          if (this.mawb) {
            this.mappingService.uploadInvoice(this.formDataInvoice).subscribe((_data: any) => {
              this.showStatus = true;
              if (_data?.message === 'File Updated') {
                this.behaviorService.sendEvent('documentTypeEvent');
              } else if (this.shipmentID) {
                this.openConfirmDialog();
              }
            });
          } else {
            this.mappingService.uploadBabyInvoice(this.formDataInvoice).subscribe((_data: any) => {
              this.showStatus = true;
              if (_data?.message === 'File Updated') {
                this.behaviorService.sendEvent('documentTypeEvent');
              } else {
                this.openConfirmDialog();
              }
            });
          }
        }
      } else {
        this.errorDialogService.openDialog('alert.chooseFile', false);
      }
    } else {
      this.errorDialogService.openDialog('alert.selectDocumentType', false);
    }
  }
  // Address-upload
  uploadAddressContent() {
    if (this.addressTypeCode) {
      if (this.selectedFileName) {
        if (this.selectedFileSize >= 5242880) {
          this.errorDialogService.openDialog(validForCISizeMessage, false);
        } else {
          this.addressService.uploadAddress(this.formDataAddress).subscribe((data: any) => {
            this.showStatus = true;
            if (data?.message === 'File Updated') {
              this.behaviorService.sendEvent('documentTypeEvent');
            }
            if (data?.Message) {
              this.errorDialogService.openDialog(data.Message, false);
            }
          });
        }
      } else {
        this.errorDialogService.openDialog('alert.chooseFile', false);
      }
    } else {
      this.errorDialogService.openDialog('alert.selectAddressType', false);
    }
  }

  //TODO: Make is independent component so that all confirmation can be replaced
  openConfirmDialog() {
    this.confirmDialogRef = this.dialog.open(this.confirmDialog, { data: '' });
  }

  replace() {
    this.typeCodeFileExist = true;
    this.formDataInvoice.set('replace', String(this.typeCodeFileExist));
    this.confirmDialogRef.close({ data: '' });
    this.uploadInvoiceContent();
  }

  closeDialog() {
    this.confirmDialogRef.close({ data: '' });
  }
  getCustomerCredentialConfig() {
    this.configService.fetchConfig('customer_credential').then(response => {
      this.postalLocationApiKey =
        response && Object.keys(response).length != 0 && response.data[0]?.postalLocationApiKey
          ? response.data[0].postalLocationApiKey
          : '';
      this.mydhlApiKey =
        response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiKey
          ? response.data[0].mydhlApiKey
          : '';
      this.mydhlApiPassword =
        response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiPassword
          ? response.data[0].mydhlApiPassword
          : '';
    });
  }
  openCustomerCredentialNav(msg) {
    const dialogRef = this.dialog.open(InvalidDialogComponent, {
      data: {
        message: msg,
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      this.dialog.closeAll();
      if (res == 'true') {
        this.behaviorService.sendEvent(res);
        this.router.navigateByUrl('/customer-onboarding');
      }
    });
  }
}